import {get} from 'lodash';


export function getSchoolCurriculumId(me) {
    return get(me, 'school.curriculum_id', 1);
}

export function extractTopics(challenge_versions, curriculum_id, subject) {
    let topics = [];

    challenge_versions.filter(challenge_version => challenge_version.challenge_code.subject === subject).map(challenge_version => {
        challenge_version.challenge_code.standards
            .filter(standard => standard.curriculum_id === curriculum_id)
            .map(standard => {
                if (!topics.includes(standard.topic)) {
                    topics.push(standard.topic);
                }
            });
    });

    return topics.sort();
}

export function extractGrades(challenge_versions, curriculum_id, subject) {
    let grades = [];

    challenge_versions.filter(challenge_version => challenge_version.challenge_code.subject === subject).map(challenge_version => {
        challenge_version.challenge_code.standards
            .filter(standard => standard.curriculum_id === curriculum_id)
            .map(standard => {
                if (!grades.includes(standard.grade)) {
                    grades.push(standard.grade);
                }
            });
    });

    return grades.sort((a, b) => a.localeCompare(b, undefined, {numeric: true, sensitivity: 'base'}));
}

// curriculum_id is accepted for signature consistency only. Themes are not curriculum scoped.
export function extractThemes(challenge_versions, curriculum_id, subject) {
    let themes = [];

    challenge_versions.filter(challenge_version => challenge_version.challenge_code.subject === subject).map(challenge_version => {
        challenge_version.challenge_code.themes
            .map(theme => {
                if (themes.indexOf(theme) < 0) {
                    themes.push(theme);
                }
            });
    });

    return themes.sort();
}

export function getCategoryText(grade) {
    switch (grade.toString()) {
        case '2':
        case '3':
        case '4':
        case '5':
            return 'Beginner'
        case '6':
        case '7':
        case '7 - 9':
            return 'Intermediate'
        case '8':
        case '9':
        case '10':
        case '11':
        case '9 - 12':
        case 'GCSE':
            return 'Advanced'
        default:
            return grade
    }
}

export function sortCategories(categories) {
    let ordered_categories = {};
    if (categories.hasOwnProperty('Beginner')) {
        ordered_categories['Beginner'] = categories['Beginner'];
    }
    if (categories.hasOwnProperty('Intermediate')) {
        ordered_categories['Intermediate'] = categories['Intermediate'];
    }
    if (categories.hasOwnProperty('Middle School')) {
        ordered_categories['Middle School'] = categories['Middle School'];
    }
    if (categories.hasOwnProperty('Advanced')) {
        ordered_categories['Advanced'] = categories['Advanced'];
    }
    if (categories.hasOwnProperty('High School')) {
        ordered_categories['High School'] = categories['High School'];
    }

    return ordered_categories;
}
